<template>
    <div class="AddNewTeam">
        <b-form class="full-width" @submit="AddTeam">
            <b-row>
                <b-col lg="6">
                    <h2>Team Information</h2>
                    <b-form-group label="Name:">
                        <b-form-input
                            type="text"
                            v-model="NewTeam.Name"
                            required
                            autocomplete="off"
                        />
                    </b-form-group>
                    <b-form-group label="Address:">
                        <b-form-input 
                            type="text"
                            v-model="NewTeam.AddressLine"
                            required
                            autocomplete="off"
                            placeholder="Address Line"
                        />
                        <b-row>
                            <b-col>
                                <b-form-input 
                                    type="text"
                                    v-model="NewTeam.City"
                                    required
                                    autocomplete="off"
                                    placeholder="City"
                                />
                            </b-col>
                            <b-col>
                                <select class="form-control" v-model="NewTeam.State" required>
                                    <option value="">Select State</option>
                                    <option v-for="option in StateOptions" :value="option.value">
                                        {{option.text}}
                                    </option>
                                </select>
                            </b-col>
                            <b-col>
                                <b-form-input 
                                    type="text"
                                    v-model="NewTeam.Zip"
                                    required
                                    autocomplete="off"
                                    placeholder="Zip"
                                />
                            </b-col>
                        </b-row>
                        <select class="form-control" v-model="NewTeam.County" required>
                            <option value="">Select County</option>
                            <option v-for="option in CountyOptions" :value="option.value">
                                {{option.text}}
                            </option>
                        </select>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <h2>Regional Program Enrollment</h2>
                    <b-form-group label="Regional Wrap Program">
                        <select class="form-control" v-model="NewTeam.SubProgramID" required>
                            <option v-for="option in SubProgramOptions" :value="option.value">
                                {{option.text}}
                            </option>
                        </select>
                    </b-form-group>
                        <b-form-group label="Start Date">
                        <flat-pickr v-model="NewTeam.StartDate" class="form-control" :config="DateConfig" required></flat-pickr>
                    </b-form-group>
                </b-col>
            </b-row>
            <button class="btn btn-success form-control" type="submit">
                <i class="fa fa-plus"></i> Add Team to Program
            </button>
        </b-form>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSearch } from '@fortawesome/free-solid-svg-icons';
    library.add(faSearch);
    import { faRedo } from '@fortawesome/free-solid-svg-icons';
    library.add(faRedo);
    import { faRobot } from '@fortawesome/free-solid-svg-icons';
    library.add(faRobot);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faMinus } from '@fortawesome/free-solid-svg-icons';
    library.add(faMinus);
    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import { EventBus } from '../../../services/event-bus.js';
    export default {
        name: "AddNewTeam",
        data: function () {
            return {
                PageState: "Initial",
                NewTeam: {
                    Name: '',
                    AddressLine: '',
                    County: '',
                    City: '',
                    State: '',
                    Zip: '',
                    StartDate: '',
                    SubProgramID: ''
                },
                DateConfig: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: true
                },
            };
        },
        methods: {
            AddTeam(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Wrap/WrapTeams/AddWrapTeam", this.NewTeam, this.AddTeamSuccess, this.AddTeamError, true);
            },
            AddTeamSuccess(response) {
                // switch to team record
                console.log("Response from adding a new team:")
                console.log(response.data.data);
                this.$store.commit("Teams.TeamProfiles.Append", { WrapTeam : { Id: response.data.data.WrapTeamID  } });
                this.$parent.ChangePaneShown(response.data.data.WrapTeamID);
                // execute global update
                this.$GlobalUpdate.ExecuteGlobalUpdate();
                // Starts a new search. Hides add to progam form and show search client form
                this.ResetPage();
            },
            AddTeamError(error) {
                console.log("Team was not created")
                console.log(error);
            },
            ResetPage() {
                this.$set(this, 'NewTeam', {
                    Name: '',
                    AddressLine: '',
                    County: '',
                    City: '',
                    State: '',
                    Zip: '',
                    StartDate: '',
                    SubProgramID: ''
                });
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
        },
        computed: {
            CountyOptions: function () {
                return this.$store.state.Options.CaliforniaCounties;
            },
            StateOptions: function () {
                return this.$store.state.Options.USStateAbbreviations;
            },
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            }
        }
    }
</script>

<style scoped>
</style>